import React from "react";
import "./Cart.css";
import { useStateValue } from "../../StateProvider";
import { useTitle } from "../../hooks/useTitle";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import CartProduct from "./CartProduct";
import Subtotal from "./Subtotal";
import EmptyCart from "./EmptyCart";
import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function Cart() {
  useTitle("Cart - TrendBay");
  const [{ cart, user }] = useStateValue();

  const firstName = user
    ? (user.name || user.displayName || "").split(" ")[0] || ""
    : null;

  return (
    <div className="cart-page">
      <Navbar />
      {/* Mobile-only cart header nav */}
      <div className="cart-mob-nav">
        {firstName ? `${firstName}'s Cart` : "Your Cart"}
      </div>
      {cart.length === 0 ? (
        <EmptyCart />
      ) : (
        <div className="cart-wrap">
          <div className="cart-header">
            {firstName && <p className="cart-greeting">Hello, {firstName}</p>}
            <h1 className="cart-title">Your Cart</h1>
          </div>
          <div className="cart-layout">
            <div className="cart-items">
              {cart.map((item) => (
                <CartProduct
                  key={item.id}
                  product_id={item.id}
                  productImage={item.image}
                  productName={item.title}
                  price={item.price}
                  category={item.category}
                  available={item.available}
                />
              ))}
              <Link to="/shop/all" className="cart-continue">
                <ChevronLeft size={15} /> Continue Shopping
              </Link>
            </div>
            <div className="cart-summary">
              <Subtotal />
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}
